/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** TransportModeEnum */
export enum TransportModeEnum {
  CAR = 'CAR',
  MOTORCYCLE = 'MOTORCYCLE',
  PUBLIC_TRANSIT = 'PUBLIC_TRANSIT',
}

/** ShiftTypeEnum */
export enum ShiftTypeEnum {
  WORK = 'WORK',
  SICK_LEAVE = 'SICK_LEAVE',
  ANNUAL_LEAVE = 'ANNUAL_LEAVE',
  UNPAID_LEAVE = 'UNPAID_LEAVE',
  OTHER_LEAVE = 'OTHER_LEAVE',
}

/** GenderEnum */
export enum GenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}

/** CaregiverPaymentType */
export enum CaregiverPaymentType {
  CostBased = 'cost_based',
  Hourly = 'hourly',
  Salary = 'salary',
}

/**
 * ApplyAssignmentsRequest
 * Request to apply confirmed scheduling assignments.
 */
export interface ApplyAssignmentsRequest {
  /**
   * Assignments
   * List of visit-caregiver assignments to apply
   * @maxItems 1000
   */
  assignments: VisitAssignmentInput[];
  /**
   * Replaceexisting
   * If True, replace existing assignments for these visits
   * @default true
   */
  replaceExisting?: boolean;
}

/**
 * ApplyAssignmentsResult
 * Result of applying assignments to database.
 */
export interface ApplyAssignmentsResult {
  /**
   * Appliedcount
   * Number of assignments successfully applied
   */
  appliedCount: number;
  /**
   * Visitids
   * List of visit IDs that were updated
   */
  visitIds: number[];
  /**
   * Executiontimeseconds
   * Total execution time in seconds
   */
  executionTimeSeconds: number;
}

/**
 * AvailabilitySlotReq
 * One wall-clock window a coordinator needs staffed, identified by ordinal.
 *
 * Shares ``ServiceRequestLineSlotCreateReq``'s ``ordinal``/``start_time``/
 * ``end_time`` shape, without the services that only matter when billing.
 *
 * NOT interchangeable with it any more, and this is load-bearing. A line's slot
 * bounds became timezone-aware instants in
 * ``20260805120000_slot-times-timezone-aware``; these are still naive
 * ``datetime.time``, which is correct — "who is free 09:00-10:00 on these dates"
 * has no instant in it, and a caller asking about dates it has not created
 * anything for has no anchor to offer.
 *
 * So a line's slots CANNOT be handed to this search verbatim (the docstring here
 * used to say they could, and that assumption 500'd
 * ``POST /caregivers/availability/by-slots`` with "start_time must be
 * timezone-aware"). Convert at the boundary: ``get_caregiver_slot_availability``
 * combines each wall clock with the date under test in the request's zone before
 * calling ``expand_line``.
 */
export interface AvailabilitySlotReq {
  /**
   * Ordinal
   * Stable identity of the slot within the request
   * @min 1
   */
  ordinal: number;
  /**
   * Starttime
   * Local wall-clock start of the slot
   * @format time
   */
  startTime: string;
  /**
   * Endtime
   * Local wall-clock end of the slot
   * @format time
   */
  endTime: string;
}

/** BatchShiftCreate */
export interface BatchShiftCreate {
  /**
   * Shifts
   * List of shifts to create
   * @maxItems 1000
   * @minItems 1
   */
  shifts: ShiftCreate[];
}

/** BatchShiftCreateResult */
export interface BatchShiftCreateResult {
  /**
   * Createdcount
   * Number of shifts successfully created
   */
  createdCount: number;
  /**
   * Shiftids
   * IDs of the created shifts
   */
  shiftIds: number[];
}

/** BatchShiftDelete */
export interface BatchShiftDelete {
  /**
   * Shiftids
   * List of shift IDs to delete
   * @maxItems 1000
   * @minItems 1
   */
  shiftIds: number[];
}

/** BatchShiftDeleteResult */
export interface BatchShiftDeleteResult {
  /**
   * Deletedcount
   * Number of shifts successfully deleted
   */
  deletedCount: number;
  /**
   * Shiftids
   * IDs of the deleted shifts
   */
  shiftIds: number[];
  /**
   * Conflictingvisits
   * Visits that were unassigned due to shift deletion
   */
  conflictingVisits?: CaregiverVisitConflict[];
}

/** BatchShiftUpdate */
export interface BatchShiftUpdate {
  /**
   * Shifts
   * List of shifts to update
   * @maxItems 1000
   * @minItems 1
   */
  shifts: ShiftUpdateItem[];
}

/** BatchShiftUpdateResult */
export interface BatchShiftUpdateResult {
  /**
   * Updatedcount
   * Number of shifts successfully updated
   */
  updatedCount: number;
  /**
   * Shiftids
   * IDs of the updated shifts
   */
  shiftIds: number[];
  /**
   * Conflictingvisits
   * Visits that conflict with the updated shifts
   */
  conflictingVisits?: CaregiverVisitConflict[];
}

/** Body_importCaregiversCommit */
export interface BodyImportCaregiversCommit {
  /**
   * File
   * @format binary
   */
  file: File;
  /**
   * Update
   * @default false
   */
  update?: boolean;
}

/** Body_importCaregiversPreview */
export interface BodyImportCaregiversPreview {
  /**
   * File
   * @format binary
   */
  file: File;
  /**
   * Update
   * @default false
   */
  update?: boolean;
}

/**
 * BulkShiftCaregiverOps
 * Every change one caregiver's schedule needs, in one entry.
 *
 * The three lists are the three things a schedule edit can be, and they are sent
 * TOGETHER because they describe one intent: "this caregiver's week should end up
 * looking like this". Splitting them across calls is what the per-caregiver batch
 * endpoints force a client to do, and it is why scheduling thirty caregivers cost
 * ninety requests.
 */
export interface BulkShiftCaregiverOps {
  /**
   * Caregiverid
   * The caregiver these changes belong to
   */
  caregiverId: number;
  /**
   * Create
   * Shifts to create for this caregiver
   * @maxItems 1000
   */
  create?: ShiftCreate[];
  /**
   * Update
   * Shifts to update, each naming its shift_id
   * @maxItems 1000
   */
  update?: ShiftUpdateItem[];
  /**
   * Delete
   * IDs of shifts to delete for this caregiver
   * @maxItems 1000
   */
  delete?: number[];
}

/**
 * BulkShiftCaregiverResult
 * What the request did to one caregiver.
 */
export interface BulkShiftCaregiverResult {
  /** Caregiverid */
  caregiverId: number;
  /** Createdshiftids */
  createdShiftIds?: number[];
  /** Updatedshiftids */
  updatedShiftIds?: number[];
  /** Deletedshiftids */
  deletedShiftIds?: number[];
  /**
   * Conflictingvisits
   * Visits unassigned by this caregiver's changes (force only)
   */
  conflictingVisits?: CaregiverVisitConflict[];
}

/**
 * BulkShiftRequest
 * One write covering many caregivers.
 */
export interface BulkShiftRequest {
  /**
   * Operations
   * Per-caregiver changes, one entry per caregiver
   * @maxItems 1000
   * @minItems 1
   */
  operations: BulkShiftCaregiverOps[];
}

/**
 * BulkShiftResult
 * Totals, plus the per-caregiver breakdown behind them.
 *
 * The totals alone would not let a caller say WHICH caregiver a conflict belongs
 * to, and a screen that scheduled thirty people has to be able to name them.
 */
export interface BulkShiftResult {
  /**
   * Createdcount
   * Shifts created across all caregivers
   */
  createdCount: number;
  /**
   * Updatedcount
   * Shifts updated across all caregivers
   */
  updatedCount: number;
  /**
   * Deletedcount
   * Shifts deleted across all caregivers
   */
  deletedCount: number;
  /** Results */
  results?: BulkShiftCaregiverResult[];
  /**
   * Conflictingvisits
   * Every conflicting visit, flattened, for callers that only count them
   */
  conflictingVisits?: CaregiverVisitConflict[];
}

/** CalendarEvent */
export interface CalendarEvent {
  /**
   * Start
   * @format date-time
   */
  start: string;
  /**
   * End
   * @format date-time
   */
  end: string;
  /** Caregivers */
  caregivers?: CaregiverAvailabilityResponse[];
  /** Isavailable */
  isAvailable: boolean;
}

/** CaregiverAvailability */
export interface CaregiverAvailability {
  /** Eventsbydate */
  eventsByDate?: Record<string, CalendarEvent[]>;
}

/** CaregiverAvailabilityByDatesRequest */
export interface CaregiverAvailabilityByDatesRequest {
  /**
   * Dates
   * List of individual dates to check (UTC)
   */
  dates: string[];
  /**
   * Durationminutes
   * Slot duration in minutes
   * @exclusiveMin 0
   */
  durationMinutes: number;
  /**
   * Caregiverids
   * Filter by caregiver IDs
   */
  caregiverIds?: number[] | null;
  /**
   * Serviceids
   * Filter by caregiver service IDs
   */
  serviceIds?: number[] | null;
  /**
   * Enabledonly
   * Consider only enabled caregivers
   */
  enabledOnly?: boolean;
  /**
   * Activeonly
   * Consider only active caregivers
   */
  activeOnly?: boolean;
}

/** CaregiverAvailabilityResponse */
export interface CaregiverAvailabilityResponse {
  /** Caregiverid */
  caregiverId: number;
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
}

/**
 * CaregiverBulkChanges
 * The fields a bulk edit may set, all optional.
 *
 * Absent, null and [] are three different instructions, so callers must read this with
 * `model_dump(exclude_unset=True)`. `exclude_none` would collapse "leave this alone" into
 * "set it to null" and silently blank fields nobody ticked.
 *
 * Identity fields (name, email, phone, national id) and pay fields are deliberately absent;
 * `extra="forbid"` makes sending one a 400 rather than a silent no-op. So is `enabled`:
 * it has no `caregivers` column, it derives from user_def_is_enabled(user_id).
 */
export interface CaregiverBulkChanges {
  /** Services */
  services?: number[] | null;
  /** Languagesspoken */
  languagesSpoken?: string[] | null;
  /** Skills */
  skills?: string[] | null;
  /** Certifications */
  certifications?: string[] | null;
  /** Specialties */
  specialties?: string[] | null;
  /** Coverageareas */
  coverageAreas?: string[] | null;
  gender?: GenderEnum | null;
  /** Active */
  active?: boolean | null;
  transportMode?: TransportModeEnum | null;
  /** Travelradiuskm */
  travelRadiusKm?: number | null;
  /** Caregivergroupid */
  caregiverGroupId?: number | null;
}

/** CaregiverBulkUpdateRequest */
export interface CaregiverBulkUpdateRequest {
  /**
   * Caregiverids
   * @maxItems 1000
   * @minItems 1
   */
  caregiverIds: number[];
  /**
   * The fields a bulk edit may set, all optional.
   *
   * Absent, null and [] are three different instructions, so callers must read this with
   * `model_dump(exclude_unset=True)`. `exclude_none` would collapse "leave this alone" into
   * "set it to null" and silently blank fields nobody ticked.
   *
   * Identity fields (name, email, phone, national id) and pay fields are deliberately absent;
   * `extra="forbid"` makes sending one a 400 rather than a silent no-op. So is `enabled`:
   * it has no `caregivers` column, it derives from user_def_is_enabled(user_id).
   */
  changes: CaregiverBulkChanges;
}

/** CaregiverBulkUpdateResponse */
export interface CaregiverBulkUpdateResponse {
  /** Updatedcount */
  updatedCount: number;
  /** Notfoundids */
  notFoundIds?: number[];
}

/** CaregiverCreate */
export interface CaregiverCreate {
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
  /** Dateofbirth */
  dateOfBirth?: string | null;
  gender?: GenderEnum | null;
  /** Nationalid */
  nationalId?: string | null;
  /** Userid */
  userId?: number | null;
  /**
   * Enabled
   * @default true
   */
  enabled?: boolean | null;
  /** Caregivergroupid */
  caregiverGroupId?: number | null;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Street */
  street?: string | null;
  /** City */
  city: string;
  /** Postalcode */
  postalCode?: string | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Travelradiuskm */
  travelRadiusKm?: number | null;
  /** Coverageareas */
  coverageAreas?: string[] | null;
  transportMode?: TransportModeEnum | null;
  /**
   * Services
   * @minItems 1
   */
  services: number[];
  /** Certifications */
  certifications?: string[] | null;
  /** Skills */
  skills?: string[] | null;
  /** Specialties */
  specialties?: string[] | null;
  /** Languagesspoken */
  languagesSpoken?: string[] | null;
  /** Hourlyrate */
  hourlyRate?: number | null;
  /** @default "cost_based" */
  paymentType?: CaregiverPaymentType;
  /** Monthlysalary */
  monthlySalary?: number | null;
  /** Rating */
  rating?: number | null;
  /**
   * Active
   * @default true
   */
  active?: boolean;
}

/** CaregiverDayRoute */
export interface CaregiverDayRoute {
  /** Caregiverid */
  caregiverId: number;
  /** Caregiverfirstname */
  caregiverFirstName: string;
  /** Caregiverlastname */
  caregiverLastName: string;
  /**
   * Date
   * @format date
   */
  date: string;
  /** Visitcount */
  visitCount: number;
  /** Totaldistancemeters */
  totalDistanceMeters: number;
  /** Totaldurationseconds */
  totalDurationSeconds: number;
  /** Legs */
  legs: RouteLeg[];
  /**
   * Geometry
   * [lat, lng] points of the road path; null unless include_geometry
   */
  geometry?: any[][] | null;
  /**
   * Skippedvisitids
   * Visits without coordinates
   */
  skippedVisitIds?: number[];
  /**
   * Stops
   * Every visit of the caregiver-day, in (start_time, visit_id) order
   */
  stops?: RouteStop[];
  /**
   * Error
   * "routing_failed" when Mapbox failed for this day
   */
  error?: string | null;
}

/** CaregiverGroup */
export interface CaregiverGroup {
  /**
   * Name
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /** Description */
  description?: string | null;
  /**
   * Caregivergroupid
   * Primary key
   */
  caregiverGroupId: number;
  /** Createdat */
  createdAt?: string | null;
}

/** CaregiverGroupCreate */
export interface CaregiverGroupCreate {
  /**
   * Name
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /** Description */
  description?: string | null;
}

/** CaregiverGroupUpdate */
export interface CaregiverGroupUpdate {
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
}

/** CaregiverGroupsGetAllPaginationResponse */
export interface CaregiverGroupsGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: CaregiverGroup[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** CaregiverMinified */
export interface CaregiverMinified {
  /** Caregiverid */
  caregiverId: number;
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
  /** Dateofbirth */
  dateOfBirth?: string | null;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /** Email */
  email: string;
  /** Street */
  street?: string | null;
  /** City */
  city: string;
  /** Postalcode */
  postalCode?: string | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Travelradiuskm */
  travelRadiusKm?: number | null;
}

/**
 * CaregiverScheduleBlocks
 * Schedule blocks showing when a caregiver is available/unavailable
 */
export interface CaregiverScheduleBlocks {
  /**
   * Caregiverid
   * Caregiver ID
   */
  caregiverId: number;
  /**
   * Firstname
   * Caregiver first name
   */
  firstName: string;
  /**
   * Lastname
   * Caregiver last name
   */
  lastName: string;
  /**
   * Availableintervals
   * Time intervals when this caregiver is available
   */
  availableIntervals: TimeInterval[];
}

/** CaregiverShift */
export interface CaregiverShift {
  /** Caregivershiftid */
  caregiverShiftId: number;
  /** Caregiverid */
  caregiverId: number;
  /**
   * Periodfrom
   * @format date-time
   */
  periodFrom: string;
  /**
   * Periodto
   * @format date-time
   */
  periodTo: string;
  /** Notes */
  notes?: string | null;
  /** @default "WORK" */
  shiftType?: ShiftTypeEnum;
  /**
   * Iswholeday
   * @default false
   */
  isWholeDay?: boolean;
}

/** CaregiverShiftDeleteResult */
export interface CaregiverShiftDeleteResult {
  oldShiftData?: CaregiverShift | null;
  /**
   * Conflictingvisits
   * @default []
   */
  conflictingVisits?: CaregiverVisitConflict[];
  /** Deletedshift */
  deletedShift?: number | null;
}

/** CaregiverShiftUpdateResult */
export interface CaregiverShiftUpdateResult {
  oldShiftData?: CaregiverShift | null;
  updatedShift?: CaregiverShift | null;
  /**
   * Conflictingvisits
   * @default []
   */
  conflictingVisits?: CaregiverVisitConflict[];
}

/** CaregiverShiftsPaginatedResponse */
export interface CaregiverShiftsPaginatedResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: CaregiverShift[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/**
 * CaregiverSlotAvailability
 * Slot-keyed availability, grouped by local date then slot ordinal.
 */
export interface CaregiverSlotAvailability {
  /**
   * Timezone
   * The timezone the dates and slot times were resolved in
   */
  timezone: string;
  /**
   * Availabilitybydate
   * Local ISO date -> that date's answer
   */
  availabilityByDate?: Record<string, SlotAvailabilityForDate>;
}

/**
 * CaregiverSlotAvailabilityRequest
 * Ask "for these dates, and these wall-clock windows, who is free — per window?"
 *
 * ``dates`` matches ``CaregiverAvailabilityByDatesRequest`` so the dashboard's
 * existing habit of posting a list of picked days carries over. Unlike that
 * request the dates are **local** dates in ``timezone``, not UTC dates.
 */
export interface CaregiverSlotAvailabilityRequest {
  /**
   * Dates
   * Local dates to check, in `timezone`
   * @minItems 1
   */
  dates: string[];
  /**
   * Slots
   * Wall-clock windows to check on every date
   * @minItems 1
   */
  slots: AvailabilitySlotReq[];
  /**
   * Timezone
   * IANA timezone the dates and slot times are expressed in. Falls back to the client's timezone when `clientId` is given, otherwise to the deployment default.
   */
  timezone?: string | null;
  /**
   * Clientid
   * Resolve `timezone` from this client when it is not supplied
   */
  clientId?: number | null;
  /**
   * Caregiverids
   * Filter by caregiver IDs
   */
  caregiverIds?: number[] | null;
  /**
   * Serviceids
   * Filter by caregiver service IDs
   */
  serviceIds?: number[] | null;
  /**
   * Enabledonly
   * Consider only enabled caregivers
   */
  enabledOnly?: boolean | null;
  /**
   * Activeonly
   * Consider only active caregivers
   */
  activeOnly?: boolean | null;
}

/** CaregiverUpdate */
export interface CaregiverUpdate {
  /** Firstname */
  firstName?: string | null;
  /** Lastname */
  lastName?: string | null;
  /** Dateofbirth */
  dateOfBirth?: string | null;
  gender?: GenderEnum | null;
  /** Nationalid */
  nationalId?: string | null;
  /** Userid */
  userId?: number | null;
  /** Enabled */
  enabled?: boolean | null;
  /** Caregivergroupid */
  caregiverGroupId?: number | null;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /** Email */
  email?: string | null;
  /** Street */
  street?: string | null;
  /** City */
  city?: string | null;
  /** Postalcode */
  postalCode?: string | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Travelradiuskm */
  travelRadiusKm?: number | null;
  /** Coverageareas */
  coverageAreas?: string[] | null;
  transportMode?: TransportModeEnum | null;
  /** Services */
  services?: number[] | null;
  /** Certifications */
  certifications?: string[] | null;
  /** Skills */
  skills?: string[] | null;
  /** Specialties */
  specialties?: string[] | null;
  /** Languagesspoken */
  languagesSpoken?: string[] | null;
  /** Hourlyrate */
  hourlyRate?: number | null;
  /** @default "cost_based" */
  paymentType?: CaregiverPaymentType;
  /** Monthlysalary */
  monthlySalary?: number | null;
  /** Rating */
  rating?: number | null;
  /** Active */
  active?: boolean | null;
  /** Requiredactions */
  requiredActions?: ('UPDATE_PASSWORD' | 'VERIFY_EMAIL')[] | null;
}

/** CaregiverVisitConflict */
export interface CaregiverVisitConflict {
  /** Visitid */
  visitId: number;
  /**
   * Visitstarttime
   * @format date-time
   */
  visitStartTime: string;
  /**
   * Visitendtime
   * @format date-time
   */
  visitEndTime: string;
  /** Address */
  address: string;
  client: ClientMinified;
  caregiver: CaregiverMinified;
}

/** CaregiverWithServices */
export interface CaregiverWithServices {
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
  /** Dateofbirth */
  dateOfBirth?: string | null;
  gender?: GenderEnum | null;
  /** Nationalid */
  nationalId?: string | null;
  /** Userid */
  userId?: number | null;
  /** Enabled */
  enabled?: boolean | null;
  /** Caregivergroupid */
  caregiverGroupId?: number | null;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /** Email */
  email: string;
  /** Street */
  street?: string | null;
  /** City */
  city: string;
  /** Postalcode */
  postalCode?: string | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Travelradiuskm */
  travelRadiusKm?: number | null;
  /** Coverageareas */
  coverageAreas?: string[] | null;
  transportMode?: TransportModeEnum | null;
  /** Services */
  services: ServiceDb[];
  /** Certifications */
  certifications?: string[] | null;
  /** Skills */
  skills?: string[] | null;
  /** Specialties */
  specialties?: string[] | null;
  /** Languagesspoken */
  languagesSpoken?: string[] | null;
  /** Hourlyrate */
  hourlyRate?: number | null;
  /** @default "cost_based" */
  paymentType?: CaregiverPaymentType;
  /** Monthlysalary */
  monthlySalary?: number | null;
  /** Rating */
  rating?: number | null;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** Caregiverid */
  caregiverId: number;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
}

/**
 * CaregiverWorkload
 * Assigned vs rostered hours for one caregiver over a time window.
 */
export interface CaregiverWorkload {
  /**
   * Caregiverid
   * The caregiver's id
   */
  caregiverId: number;
  /**
   * Firstname
   * The caregiver's first name
   */
  firstName: string;
  /**
   * Lastname
   * The caregiver's last name
   */
  lastName: string;
  /**
   * Visitcount
   * Number of non-cancelled visits assigned to this caregiver that overlap the window
   */
  visitCount: number;
  /**
   * Shiftcount
   * Number of WORK shifts overlapping the window
   */
  shiftCount: number;
  /**
   * Assignedhours
   * Total hours of assigned visits, clamped to the window boundaries (2 decimal places)
   */
  assignedHours: number;
  /**
   * Rosteredhours
   * Total hours of WORK shifts, clamped to the window boundaries (2 decimal places)
   */
  rosteredHours: number;
  /**
   * Utilizationpct
   * assignedHours / rosteredHours * 100, to 2 decimal places. NULL when no WORK shifts are recorded in the window: the denominator is unknown, NOT zero. A caregiver with no roster is of unknown availability, not idle capacity, so clients must render this as 'unknown' (e.g. an em-dash) and never as 0%.
   */
  utilizationPct?: number | null;
}

/** CaregiversGetAllMinifiedPaginationResponse */
export interface CaregiversGetAllMinifiedPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: CaregiverMinified[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** CaregiversGetAllPaginationResponse */
export interface CaregiversGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: CaregiverWithServices[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** ClientMinified */
export interface ClientMinified {
  /** Clientid */
  clientId: number | null;
  /** Firstname */
  firstName?: string | null;
  /** Lastname */
  lastName?: string | null;
  /** City */
  city?: string | null;
  /** Street */
  street?: string | null;
  /** Postalcode */
  postalCode?: string | null;
  /** Floor */
  floor?: number | null;
}

/**
 * DailyScheduleRequest
 * Request for caregiver daily schedules on a specific date
 */
export interface DailyScheduleRequest {
  /**
   * Date
   * Date to get schedules for
   * @format date
   */
  date: string;
  /**
   * Serviceids
   * Filter caregivers by service IDs
   */
  serviceIds?: number[] | null;
  /**
   * Caregiverids
   * Limit to specific caregiver IDs
   */
  caregiverIds?: number[] | null;
  /**
   * Enabledonly
   * Filter by enabled status. None = show all, True = enabled only, False = disabled only
   */
  enabledOnly?: boolean | null;
  /**
   * Activeonly
   * Filter by active status. None = show all, True = active only, False = inactive only
   */
  activeOnly?: boolean | null;
}

/**
 * DailyScheduleResponse
 * Response containing daily schedule data for multiple caregivers
 */
export interface DailyScheduleResponse {
  /**
   * Date
   * Date for the schedule data
   * @format date
   */
  date: string;
  /**
   * Caregivers
   * List of caregivers with their availability intervals
   */
  caregivers: CaregiverScheduleBlocks[];
  /**
   * Unavailableintervals
   * Time intervals when NO caregivers are available
   */
  unavailableIntervals: TimeInterval[];
}

/** ExportColumnRequest */
export interface ExportColumnRequest {
  /** Key */
  key: string;
  /** Header */
  header: string;
}

/** ExportRequest */
export interface ExportRequest {
  /** Format */
  format: 'csv' | 'xlsx';
  /**
   * Columns
   * @maxItems 200
   * @minItems 1
   */
  columns: ExportColumnRequest[];
  /** Params */
  params?: Record<string, any>;
}

/** ExportStarted */
export interface ExportStarted {
  /** Exportid */
  exportId: number;
}

/** ExternalProvider */
export interface ExternalProvider {
  /**
   * Name
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /** Phone */
  phone?: string | null;
  /** Email */
  email?: string | null;
  /** Notes */
  notes?: string | null;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** Externalproviderid */
  externalProviderId: number;
  /** Createdat */
  createdAt?: string | null;
  /** Updatedat */
  updatedAt?: string | null;
  /**
   * Services
   * @default []
   */
  services?: ExternalProviderServicePopulated[];
}

/** ExternalProviderCreate */
export interface ExternalProviderCreate {
  /**
   * Name
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /** Phone */
  phone?: string | null;
  /** Email */
  email?: string | null;
  /** Notes */
  notes?: string | null;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Services
   * @default []
   */
  services?: ExternalProviderService[];
}

/** ExternalProviderService */
export interface ExternalProviderService {
  /** Serviceid */
  serviceId: number;
  /** Costeuros */
  costEuros?: number | string | null;
}

/** ExternalProviderServicePopulated */
export interface ExternalProviderServicePopulated {
  /** Serviceid */
  serviceId: number;
  /** Costeuros */
  costEuros?: number | null;
  /** Servicename */
  serviceName: string;
}

/** ExternalProviderUpdate */
export interface ExternalProviderUpdate {
  /** Name */
  name?: string | null;
  /** Phone */
  phone?: string | null;
  /** Email */
  email?: string | null;
  /** Notes */
  notes?: string | null;
  /** Active */
  active?: boolean | null;
  /** Services */
  services?: ExternalProviderService[] | null;
}

/** ExternalProvidersGetAllPaginationResponse */
export interface ExternalProvidersGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: ExternalProvider[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** ImportCounts */
export interface ImportCounts {
  /**
   * Create
   * @default 0
   */
  create?: number;
  /**
   * Update
   * @default 0
   */
  update?: number;
  /**
   * Skip
   * @default 0
   */
  skip?: number;
  /**
   * Errors
   * @default 0
   */
  errors?: number;
  /**
   * Warnings
   * @default 0
   */
  warnings?: number;
}

/** ImportIssue */
export interface ImportIssue {
  /** Sheet */
  sheet: string;
  /** Row */
  row?: number | null;
  /** Column */
  column?: string | null;
  /** Message */
  message: string;
  /**
   * Level
   * @default "error"
   */
  level?: 'error' | 'warning';
}

/** ImportReport */
export interface ImportReport {
  /**
   * Committed
   * @default false
   */
  committed?: boolean;
  counts: ImportCounts;
  /** Rows */
  rows: ImportRowResult[];
  /** Issues */
  issues: ImportIssue[];
}

/** ImportRowResult */
export interface ImportRowResult {
  /** Sheet */
  sheet: string;
  /** Row */
  row: number;
  /** Label */
  label: string;
  /** Action */
  action: 'create' | 'update' | 'skip' | 'error';
}

/** PaginatedResponse[CaregiverWorkload] */
export interface PaginatedResponseCaregiverWorkload {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: CaregiverWorkload[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** RouteDistancesRequest */
export interface RouteDistancesRequest {
  /**
   * Starttimefrom
   * Window start (inclusive), timezone-aware
   * @format date-time
   */
  startTimeFrom: string;
  /**
   * Starttimeto
   * Window end (exclusive), timezone-aware
   * @format date-time
   */
  startTimeTo: string;
  /**
   * Timezone
   * IANA zone that decides day boundaries, e.g. Europe/Athens
   * @maxLength 64
   */
  timezone: string;
  /**
   * Includegeometry
   * Return the road path for drawing on a map
   * @default false
   */
  includeGeometry?: boolean;
}

/** RouteDistancesResponse */
export interface RouteDistancesResponse {
  /** Days */
  days: CaregiverDayRoute[];
}

/** RouteLeg */
export interface RouteLeg {
  /** Fromvisitid */
  fromVisitId: number;
  /** Tovisitid */
  toVisitId: number;
  /** Distancemeters */
  distanceMeters: number;
  /** Durationseconds */
  durationSeconds: number;
}

/** RouteStop */
export interface RouteStop {
  /** Visitid */
  visitId: number;
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
  /**
   * Endtime
   * @format date-time
   */
  endTime: string;
  /** Clientid */
  clientId: number;
  /** Clientfirstname */
  clientFirstName: string;
  /** Clientlastname */
  clientLastName: string;
  /** Street */
  street?: string | null;
  /** City */
  city?: string | null;
  /** Status */
  status: string;
  /** Haslocation */
  hasLocation: boolean;
}

/**
 * SchedulingConflict
 * Represents a scheduling conflict between visits.
 */
export interface SchedulingConflict {
  /** Visitid1 */
  visitId1?: number | null;
  /** Visitid2 */
  visitId2?: number | null;
  /** Caregiverid */
  caregiverId?: number | null;
  /**
   * Conflicttype
   * Type of conflict: 'TIME_OVERLAP', 'NO_SHIFT_COVERAGE', 'OVER_CAPACITY'
   */
  conflictType: string;
  /** Details */
  details?: string | null;
  caregiver?: CaregiverMinified | null;
  visit1?: VisitForScheduling | null;
  visit2?: VisitForScheduling | null;
}

/**
 * SchedulingKPIs
 * Key Performance Indicators for scheduling quality.
 */
export interface SchedulingKPIs {
  /**
   * Avgtraveldistancekm
   * Mean distance between sequential visits per caregiver (km)
   */
  avgTravelDistanceKm?: number | null;
  /**
   * Workloadstddevminutes
   * Standard deviation of total assigned minutes per caregiver for the day
   */
  workloadStdDevMinutes?: number | null;
  /**
   * Continuityrate
   * Percentage of visits where assigned caregiver has seen the client in the last 30 days
   */
  continuityRate?: number | null;
  /**
   * Continuitygaprate
   * For visits with prior caregivers, % where none of those prior caregivers were assigned
   */
  continuityGapRate?: number | null;
  /**
   * Newpatientsrate
   * Percentage of visits where the client has no prior caregivers on record
   */
  newPatientsRate?: number | null;
  /**
   * Scarcecaregiverusage
   * Percentage of assignments going to least flexible caregivers
   */
  scarceCaregiverUsage?: number | null;
  /**
   * Visitcountstddev
   * Standard deviation of visit counts across caregivers
   */
  visitCountStdDev?: number | null;
  /**
   * Shiftcoveragehits
   * Percentage of assignments where a valid shift covers the visit
   */
  shiftCoverageHits?: number | null;
  /**
   * Servicematchrate
   * Percentage of visits where assigned caregiver covers all required services
   */
  serviceMatchRate?: number | null;
  /**
   * Conflictrate
   * Conflicts / total visits
   */
  conflictRate?: number | null;
  /**
   * Optimizationiterationsused
   * Iterations used vs max, signals optimization difficulty
   */
  optimizationIterationsUsed?: number | null;
  /**
   * Optimizationiterationsmax
   * Maximum iterations allowed
   */
  optimizationIterationsMax?: number | null;
}

/**
 * SchedulingRequest
 * Request for automatic scheduling.
 */
export interface SchedulingRequest {
  /**
   * Datefrom
   * Start date for scheduling window
   * @format date
   */
  dateFrom: string;
  /**
   * Dateto
   * End date for scheduling window
   * @format date
   */
  dateTo: string;
  /**
   * Previewonly
   * If True, only preview assignments without saving to database
   * @default true
   */
  previewOnly?: boolean;
  /**
   * Algorithm
   * Scheduling algorithm to use: 'cp_sat' (default, route engine) or 'greedy'
   * @default "cp_sat"
   */
  algorithm?: string;
  /**
   * Routeapi
   * Route calculation provider: 'mapbox' or 'google'
   * @default "mapbox"
   */
  routeApi?: string;
  /**
   * Travelmode
   * Optional provider-specific mode/profile (e.g. 'driving-traffic', 'walking', 'DRIVE')
   */
  travelMode?: string | null;
  /**
   * Usetravelconstraints
   * When True (default), build a travel-time matrix and add travel-time constraints to the CP-SAT model. Set to False to skip all route-API calls and run the solver without travel-time constraints (useful when no API key is configured or for faster preview runs).
   * @default true
   */
  useTravelConstraints?: boolean;
  /**
   * Visitids
   * Specific visit IDs to schedule. If None, all unassigned visits in date range
   */
  visitIds?: number[] | null;
  /**
   * Caregiverids
   * Limit to specific caregivers. If None, consider all available caregivers
   */
  caregiverIds?: number[] | null;
  /**
   * Serviceids
   * Filter visits by required services
   */
  serviceIds?: number[] | null;
  /** Scoring weights for the algorithm */
  weights?: SchedulingWeights | null;
  /**
   * Maxdailyminutes
   * CP-SAT: hard cap on a caregiver's visit minutes per local day, planned visits included
   */
  maxDailyMinutes?: number | null;
  /**
   * Timelimitseconds
   * CP-SAT: search time per local day (default 10 s); small days finish earlier
   */
  timeLimitSeconds?: number | null;
  /**
   * Autoresolveconflicts
   * Automatically attempt to resolve conflicts with local optimization
   * @default true
   */
  autoResolveConflicts?: boolean;
  /**
   * Maxiterations
   * Maximum iterations for conflict resolution
   * @min 1
   * @max 1000
   * @default 100
   */
  maxIterations?: number;
}

/**
 * SchedulingResult
 * Result of the scheduling operation.
 */
export interface SchedulingResult {
  /**
   * Previewmode
   * Whether this is a preview (not yet saved to database)
   * @default true
   */
  previewMode?: boolean;
  /**
   * Assignments
   * Successful caregiver-visit assignments
   */
  assignments: VisitAssignmentOutput[];
  /**
   * Unassignedvisits
   * Visits that could not be assigned with details
   */
  unassignedVisits?: UnassignedVisit[];
  /**
   * Conflicts
   * Conflicts that could not be resolved
   */
  conflicts?: SchedulingConflict[];
  /**
   * Iterations
   * Number of optimization iterations performed
   * @default 0
   */
  iterations?: number;
  /**
   * Totalvisitsprocessed
   * Total number of visits processed
   */
  totalVisitsProcessed: number;
  /**
   * Successfullyassigned
   * Number of successfully assigned visits
   */
  successfullyAssigned: number;
  /**
   * Executiontimeseconds
   * Total execution time in seconds
   */
  executionTimeSeconds: number;
  /**
   * Caregiversummary
   * Per-caregiver summary with visit count, total visit hours, first/last visits, and assigned visit IDs
   */
  caregiverSummary?: Record<string, Record<string, any>>;
  /**
   * Metadata
   * Additional metadata about the scheduling run
   */
  metadata?: Record<string, any> | null;
  /** Key Performance Indicators for this scheduling result */
  kpis?: SchedulingKPIs | null;
  /** Operational statistics: hours, utilisation rates, assignment coverage */
  statistics?: SchedulingStatistics | null;
}

/**
 * SchedulingStatistics
 * Operational statistics summarising a scheduling run.
 */
export interface SchedulingStatistics {
  /**
   * Totalvisitsinwindow
   * Total visits processed in the scheduling window
   */
  totalVisitsInWindow: number;
  /**
   * Assignedvisitscount
   * Number of visits successfully assigned to a caregiver
   */
  assignedVisitsCount: number;
  /**
   * Unassignedvisitscount
   * Number of visits that could not be assigned
   */
  unassignedVisitsCount: number;
  /**
   * Unassignednoservicematch
   * Unassigned visits where no caregiver in the pool provides all required services
   * @default 0
   */
  unassignedNoServiceMatch?: number;
  /**
   * Unassignednocoveragearea
   * Unassigned visits where every service-capable caregiver is outside the visit's geographic coverage area or travel radius (and therefore was never considered)
   * @default 0
   */
  unassignedNoCoverageArea?: number;
  /**
   * Unassignednoshiftcoverage
   * Unassigned visits where at least one caregiver has the right services but none have a shift covering the visit window
   * @default 0
   */
  unassignedNoShiftCoverage?: number;
  /**
   * Unassignedcaregiverbusy
   * Unassigned visits where every caregiver with the right services and a covering shift already has an overlapping visit in the database (pre-existing workload)
   * @default 0
   */
  unassignedCaregiverBusy?: number;
  /**
   * Unassignedbatchconflict
   * Unassigned visits where every free eligible caregiver was assigned to another overlapping visit in this same scheduling run (solver had to choose between them)
   * @default 0
   */
  unassignedBatchConflict?: number;
  /**
   * Unassignedtravelconstraint
   * Unassigned visits where eligible caregivers (services + shift + no direct overlap) exist but the gap between consecutive batch-assigned visits is too small for the required travel time
   * @default 0
   */
  unassignedTravelConstraint?: number;
  /**
   * Unassignedsolverchoice
   * Unassigned visits where a free eligible caregiver existed but the solver left the visit open (cost, workload or time limit); the unassigned_* buckets sum to unassigned_visits_count
   * @default 0
   */
  unassignedSolverChoice?: number;
  /**
   * Assignmentratepercent
   * Percentage of visits successfully assigned (0–100)
   */
  assignmentRatePercent: number;
  /**
   * Totalrequiredvisithours
   * Sum of all visit durations (assigned + unassigned) in hours
   */
  totalRequiredVisitHours: number;
  /**
   * Totalassignedvisithours
   * Sum of assigned visit durations in hours
   */
  totalAssignedVisitHours: number;
  /**
   * Estimatedcaregiverhourswithtravel
   * Total assigned visit hours × 1.3, an estimate that accounts for caregiver travel time between visits
   */
  estimatedCaregiverHoursWithTravel: number;
  /**
   * Avgvisitdurationminutes
   * Average duration of all visits in the window (minutes)
   */
  avgVisitDurationMinutes: number;
  /**
   * Caregiversinpool
   * Total caregivers considered for scheduling
   */
  caregiversInPool: number;
  /**
   * Caregiversutilized
   * Number of caregivers who received at least one assignment
   */
  caregiversUtilized: number;
  /**
   * Avgvisitsperutilizedcaregiver
   * Average number of visits per caregiver who received an assignment
   */
  avgVisitsPerUtilizedCaregiver: number;
  /**
   * Avghoursperutilizedcaregiver
   * Average visit hours per caregiver who received an assignment
   */
  avgHoursPerUtilizedCaregiver: number;
}

/**
 * SchedulingWeights
 * Priority weights.
 *
 * The CP-SAT route engine costs everything in minutes and multiplies each term by its weight
 * (0 = ignore, 1 = normal, 3 = high, 10 = very high). The greedy algorithm still reads them
 * as the relative weights of its normalised score.
 */
export interface SchedulingWeights {
  /**
   * Traveldistance
   * CP-SAT: multiplier on driving minutes along each caregiver's route (home and back included)
   * @min 0
   * @default 1
   */
  travelDistance?: number;
  /**
   * Alreadyassignedhours
   * CP-SAT: multiplier on minutes a caregiver's day goes above that day's fair share (summed with fairness_score)
   * @min 0
   * @default 0.5
   */
  alreadyAssignedHours?: number;
  /**
   * Continuitywithclient
   * CP-SAT: multiplier on the 30-minute cost of a caregiver who has not seen the client in the last 30 days
   * @min 0
   * @default 0.3
   */
  continuityWithClient?: number;
  /**
   * Caregiveravailabilityrank
   * Greedy only: prefer less flexible caregivers. Ignored by CP-SAT
   * @min 0
   * @default 0.7
   */
  caregiverAvailabilityRank?: number;
  /**
   * Fairnessscore
   * Greedy: even visit counts. CP-SAT: added to already_assigned_hours
   * @min 0
   * @default 0.4
   */
  fairnessScore?: number;
  /**
   * Unassignedvisitpenalty
   * CP-SAT: minutes a visit may cost before it is left unassigned; the default fills every visit that fits
   * @min 0
   * @default 100000
   */
  unassignedVisitPenalty?: number;
  /**
   * Timegappenalty
   * Greedy only. Ignored by CP-SAT
   * @min 0
   * @default 0.5
   */
  timeGapPenalty?: number;
  /**
   * Stability
   * CP-SAT: multiplier on the 30-minute cost of giving an assigned visit to someone else (Fewest changes)
   * @min 0
   * @default 0
   */
  stability?: number;
}

/**
 * ServiceDb
 * Model representing the DB schema of a homecare service.
 */
export interface ServiceDb {
  /**
   * Name
   * Name of the specific service
   */
  name: string;
  /**
   * Description
   * Detailed description of the service offering
   */
  description?: string | null;
  /**
   * Servicetypeid
   * ID of the service type (foreign key to ServiceType table)
   */
  serviceTypeId: number;
  /**
   * Estimatedtimeminutes
   * Estimated time required to perform the service in minutes
   * @default 0
   */
  estimatedTimeMinutes?: number | null;
  /**
   * Cost
   * Cost of the service in Euros
   */
  cost?: number | null;
  /**
   * Price
   * Price of the service in Euros
   */
  price?: number | null;
  /**
   * Isexternalservice
   * Whether service is provided by a third party
   * @default false
   */
  isExternalService?: boolean;
  /**
   * Commissionexempt
   * Whether service is excluded from commission calculation (e.g., materials, medications)
   * @default false
   */
  commissionExempt?: boolean;
  /**
   * Isactive
   * Whether the service can be selected on new work. An inactive service is retired rather than deleted: it stops appearing in pickers but stays visible on the service requests and visits that already reference it, so history is preserved. Deleting instead would fail anyway - service_request_services and visit_services hold FKs with no cascade.
   * @default true
   */
  isActive?: boolean;
  /**
   * Serviceid
   * Unique identifier for the service (PK of services table)
   */
  serviceId: number;
}

/**
 * ServiceMinified
 * Minimal service information for references.
 */
export interface ServiceMinified {
  /**
   * Serviceid
   * Unique identifier for the service (PK of services table)
   */
  serviceId: number;
  /**
   * Name
   * Name of the specific service
   */
  name: string;
}

/** ShiftCreate */
export interface ShiftCreate {
  /** Notes */
  notes: string | null;
  /**
   * Periodfrom
   * @format date-time
   */
  periodFrom: string;
  /**
   * Periodto
   * @format date-time
   */
  periodTo: string;
  /** @default "WORK" */
  shiftType?: ShiftTypeEnum;
  /**
   * Iswholeday
   * @default false
   */
  isWholeDay?: boolean;
}

/**
 * ShiftDateAvailability
 * Response model indicating which dates have shifts
 */
export interface ShiftDateAvailability {
  /**
   * Date
   * The date
   * @format date
   */
  date: string;
  /**
   * Hasshifts
   * Whether shifts exist on this date
   */
  hasShifts: boolean;
  /**
   * Shiftcount
   * Number of shifts on this date
   */
  shiftCount: number;
}

/** ShiftUpdate */
export interface ShiftUpdate {
  /** Notes */
  notes: string | null;
  /** Periodfrom */
  periodFrom: string | null;
  /** Periodto */
  periodTo: string | null;
  shiftType?: ShiftTypeEnum | null;
  /** Iswholeday */
  isWholeDay?: boolean | null;
}

/** ShiftUpdateItem */
export interface ShiftUpdateItem {
  /**
   * Shiftid
   * ID of the shift to update
   */
  shiftId: number;
  /**
   * Notes
   * Updated notes for the shift
   */
  notes?: string | null;
  /**
   * Periodfrom
   * Updated start time
   */
  periodFrom?: string | null;
  /**
   * Periodto
   * Updated end time
   */
  periodTo?: string | null;
  /** Updated shift type */
  shiftType?: ShiftTypeEnum | null;
  /**
   * Iswholeday
   * Updated whole day flag
   */
  isWholeDay?: boolean | null;
}

/**
 * SlotAvailability
 * Who can cover one slot on one date, with the slot resolved to instants.
 */
export interface SlotAvailability {
  /**
   * Ordinal
   * Ordinal of the requested slot
   */
  ordinal: number;
  /**
   * Start
   * Resolved start instant of the slot
   * @format date-time
   */
  start: string;
  /**
   * End
   * Resolved end instant: start + the slot's wall-clock duration, so the span is correct on a DST transition day
   * @format date-time
   */
  end: string;
  /**
   * Caregivers
   * Caregivers free for this whole slot
   */
  caregivers?: CaregiverAvailabilityResponse[];
  /**
   * Isavailable
   * Whether anyone can cover the slot
   */
  isAvailable: boolean;
}

/**
 * SlotAvailabilityForDate
 * One local date's answer: per-slot lists plus the whole-day intersection.
 */
export interface SlotAvailabilityForDate {
  /**
   * Slots
   * One entry per requested slot, ascending by ordinal
   */
  slots?: SlotAvailability[];
  /**
   * Caregiverscoveringallslots
   * Caregivers free for EVERY requested slot on this date — the usual answer when one caregiver should staff the whole day's set
   */
  caregiversCoveringAllSlots?: CaregiverAvailabilityResponse[];
}

/**
 * TimeInterval
 * Represents a time interval with start and end times
 */
export interface TimeInterval {
  /**
   * Start
   * Start time of the interval
   * @format date-time
   */
  start: string;
  /**
   * End
   * End time of the interval
   * @format date-time
   */
  end: string;
}

/**
 * UnassignedReasonPart
 * One translatable piece of an unassigned-visit reason.
 */
export interface UnassignedReasonPart {
  /**
   * Code
   * no_caregivers | no_service | no_area | no_shift | busy | batch_conflict | travel | solver
   */
  code: string;
  /**
   * Params
   * Template params: count (int), window ('HH:MM–HH:MM' local), services (names)
   */
  params?: Record<string, any>;
}

/**
 * UnassignedVisit
 * Information about a visit that could not be assigned.
 */
export interface UnassignedVisit {
  /** Visit information needed for scheduling. */
  visit: VisitForScheduling;
  /**
   * Reason
   * Reason why visit could not be assigned, rendered in the caller's locale
   */
  reason?: string | null;
  /**
   * Reasoncode
   * Headline reason; the same bucket the visit is counted in by SchedulingStatistics: no_service | no_area | no_shift | busy | batch_conflict | travel | solver
   */
  reasonCode?: string | null;
  /**
   * Reasonparams
   * Params for reason_code: count, window, services
   */
  reasonParams?: Record<string, any>;
  /**
   * Reasonparts
   * How many caregivers in the pool dropped out at each check
   */
  reasonParts?: UnassignedReasonPart[];
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/**
 * VisitAssignment
 * Assignment of a caregiver to a visit.
 */
export interface VisitAssignmentInput {
  /** Visitid */
  visitId: number;
  /** Caregiverid */
  caregiverId: number;
  /** Score */
  score: number;
  /**
   * Confidence
   * Confidence in this assignment (1.0 = high confidence)
   * @min 0
   * @max 1
   * @default 1
   */
  confidence?: number;
  /**
   * Travelfromvisitid
   * Previous visit ID used to calculate travel to this visit; null when travel is from caregiver base/home
   */
  travelFromVisitId?: number | null;
  /**
   * Traveltimetovisitseconds
   * Calculated travel time required to reach this visit from previous stop
   */
  travelTimeToVisitSeconds?: number | null;
  /**
   * Traveldistancetovisitmeters
   * Calculated travel distance required to reach this visit from previous stop
   */
  travelDistanceToVisitMeters?: number | null;
  caregiver?: CaregiverMinified | null;
  visit?: VisitForScheduling | null;
}

/**
 * VisitAssignment
 * Assignment of a caregiver to a visit.
 */
export interface VisitAssignmentOutput {
  /** Visitid */
  visitId: number;
  /** Caregiverid */
  caregiverId: number;
  /** Score */
  score: number;
  /**
   * Confidence
   * Confidence in this assignment (1.0 = high confidence)
   * @min 0
   * @max 1
   * @default 1
   */
  confidence?: number;
  /**
   * Travelfromvisitid
   * Previous visit ID used to calculate travel to this visit; null when travel is from caregiver base/home
   */
  travelFromVisitId?: number | null;
  /**
   * Traveltimetovisitseconds
   * Calculated travel time required to reach this visit from previous stop
   */
  travelTimeToVisitSeconds?: number | null;
  /**
   * Traveldistancetovisitmeters
   * Calculated travel distance required to reach this visit from previous stop
   */
  travelDistanceToVisitMeters?: number | null;
  caregiver?: CaregiverMinified | null;
  visit?: VisitForScheduling | null;
  /**
   * Matchquality
   * UI-friendly match quality percentage (0–100) where 100 = best possible fit.
   * Derived from the normalised cost score: `(1 - score) * 100`.
   */
  matchQuality: number;
}

/**
 * VisitForScheduling
 * Visit information needed for scheduling.
 */
export interface VisitForScheduling {
  /** Visitid */
  visitId: number;
  /** Servicerequestid */
  serviceRequestId?: number | null;
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
  /**
   * Endtime
   * @format date-time
   */
  endTime: string;
  /** Clientid */
  clientId: number;
  client?: ClientMinified | null;
  /** Status */
  status?: string | null;
  /** Street */
  street?: string | null;
  /** City */
  city?: string | null;
  /** Postalcode */
  postalCode?: string | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Requiredserviceids */
  requiredServiceIds?: number[];
  /**
   * Requiredservices
   * Required services with names for this visit
   */
  requiredServices?: ServiceMinified[];
  /** Durationminutes */
  durationMinutes: number;
  /** Assignedcaregiverids */
  assignedCaregiverIds?: number[];
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '/api/v1/caregivers-api/',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title caregivers
 * @version 1.0.0
 * @baseUrl /api/v1/caregivers-api/
 *
 *
 * Microservice for managing home care caregivers.
 *
 * ## Features
 * * Create, read, update, and delete caregiver records
 * * Manage caregiver shifts and services
 * * Secure endpoints with authentication and authorization
 *
 * ## Authentication
 * All endpoints require authentication using JWT tokens.
 * Admin endpoints require additional admin permissions.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  caregivers = {
    /**
     * @description Assigned visit hours against rostered WORK-shift hours, one row per active caregiver, for the given window. Hours are clamped to the window boundaries and cancelled visits are excluded. `shiftCount` counts the WORK shifts themselves: hours are clamped to the window, the count is not, so a shift straddling a boundary and a whole-day shift are each one shift. `utilizationPct` is null when the caregiver has no WORK shifts in the window - the denominator is unknown, not zero, so it must not be rendered as 0%.
     *
     * @tags Caregivers
     * @name ListCaregiverWorkload
     * @summary Caregiver workload for a period
     * @request GET:/caregivers/workload
     * @secure
     */
    listCaregiverWorkload: (
      query: {
        /**
         * Period From
         * Start of the window (inclusive), an absolute instant. Naive values are read as UTC.
         * @format date-time
         */
        period_from: string;
        /**
         * Period To
         * End of the window (exclusive), an absolute instant. Naive values are read as UTC.
         * @format date-time
         */
        period_to: string;
        /**
         * Offset
         * Pagination offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * Pagination limit
         * @min 1
         * @max 1000
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaginatedResponseCaregiverWorkload, void | HTTPValidationError>({
        path: `/caregivers/workload`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of caregivers who are available in the specified time range. A caregiver is considered available if they do not have any assigned visits overlapping the given `from`–`to` interval. Optionally filter caregivers by `service_id` to only include those who can provide the specified service.
     *
     * @tags Caregivers
     * @name ListAvailableCaregivers
     * @summary Get available caregivers
     * @request GET:/caregivers/available
     * @secure
     */
    listAvailableCaregivers: (
      query: {
        /**
         * From
         * Start of the time range (inclusive, ISO8601)
         * @format date-time
         * @example "2026-10-27T19:00:00+00:00"
         */
        from: string;
        /**
         * To
         * End of the time range (exclusive, ISO8601)
         * @format date-time
         * @example "2026-10-27T21:00:00+00:00"
         */
        to: string;
        /**
         * Service Ids
         * Optional service filter
         * @example [1]
         */
        service_ids?: number[] | null;
        /**
         * Enabled Only
         * Filter to only include enabled caregivers
         * @example false
         */
        enabled_only?: boolean;
        /**
         * Active Only
         * Filter to only include active caregivers
         * @example false
         */
        active_only?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<CaregiverWithServices[], void>({
        path: `/caregivers/available`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns availability for caregivers across non-continuous dates. Filters by duration, caregiver IDs, and service IDs.
     *
     * @tags Caregivers Availability
     * @name GetCaregiverAvailabilityByDates
     * @summary Get available caregivers on specific dates
     * @request POST:/caregivers/availability/by-dates
     * @secure
     */
    getCaregiverAvailabilityByDates: (data: CaregiverAvailabilityByDatesRequest, params: RequestParams = {}) =>
      this.request<CaregiverAvailability, HTTPValidationError | void>({
        path: `/caregivers/availability/by-dates`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns availability for a set of local dates and a set of wall-clock time slots, answered **per slot**: a coordinator can see that a caregiver covers slot 1 but not slot 2 on a given date. Each date also reports the caregivers who cover EVERY requested slot, which is the usual question when one caregiver should staff a whole service-request line for the day. Dates and slot times are local to `timezone`. Slot ends are derived as start + the slot's wall-clock duration, the same way the visits being staffed are generated, so the answer stays correct on DST transition days. Slot input order is irrelevant; overlapping slots are accepted and evaluated independently.
     *
     * @tags Caregivers Availability
     * @name GetCaregiverAvailabilityBySlots
     * @summary Get available caregivers per date, per time slot
     * @request POST:/caregivers/availability/by-slots
     * @secure
     */
    getCaregiverAvailabilityBySlots: (data: CaregiverSlotAvailabilityRequest, params: RequestParams = {}) =>
      this.request<CaregiverSlotAvailability, void>({
        path: `/caregivers/availability/by-slots`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns daily schedule showing when caregivers are available/unavailable on a specific date. Includes per-caregiver available time intervals and overall unavailable intervals for the day. Useful for calendar/timeline views showing coverage throughout the day.
     *
     * @tags Caregivers Availability
     * @name GetCaregiverDailySchedule
     * @summary Get caregiver daily schedule blocks
     * @request POST:/caregivers/daily-schedule
     * @secure
     */
    getCaregiverDailySchedule: (data: DailyScheduleRequest, params: RequestParams = {}) =>
      this.request<DailyScheduleResponse, HTTPValidationError | void>({
        path: `/caregivers/daily-schedule`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns caregiver availability within a continuous datetime range. Optionally filters by slot duration, caregiver IDs, and service IDs.
     *
     * @tags Caregivers Availability
     * @name GetCaregiverAvailabilityByRange
     * @summary Get available caregivers in a datetime range
     * @request GET:/caregivers/availability/by-range
     * @secure
     */
    getCaregiverAvailabilityByRange: (
      query: {
        /**
         * From Date
         * Start of date range (UTC)
         * @format date
         * @example "2020-10-08"
         */
        from_date: string;
        /**
         * To Date
         * End of date range (UTC)
         * @format date
         * @example "2020-10-15"
         */
        to_date: string;
        /**
         * Duration Minutes
         * Slot duration in minutes
         * @default 30
         * @example 60
         */
        duration_minutes?: number | null;
        /**
         * Caregiver Ids
         * Filter by caregiver IDs
         * @example [1,2,3]
         */
        caregiver_ids?: number[] | null;
        /**
         * Service Ids
         * Filter by caregiver service IDs
         * @example [10,20]
         */
        service_ids?: number[] | null;
        /**
         * Enabled Only
         * Filter by enabled status. None = show all, True = enabled only, False = disabled only
         */
        enabled_only?: boolean | null;
        /**
         * Active Only
         * Filter by active status. None = show all, True = active only, False = inactive only
         */
        active_only?: boolean | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<CaregiverAvailability, HTTPValidationError | void>({
        path: `/caregivers/availability/by-range`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a paginated list of caregivers with support for: - **Free-text search** (query parameter) - **Simple filters** (services, active, city, skills, languages_spoken, rating_min, rating_max) - **Advanced JSON:API filters** (filter[field][op]=value) All three types of filters can be combined and work together using AND logic. **Free-text search:** - Use 'query' parameter (min 3 chars) to search by first/last name, email, phone, or service names **Simple filters:** - services: Filter by service IDs (array) - active: Filter by active status (boolean) - city: Filter by city (ILIKE match) - skills: Filter by skills - match any (array overlap) - languages_spoken: Filter by languages spoken - match any (array overlap) - rating_min / rating_max: Filter by rating range **Advanced filters:** - Use JSON:API filter syntax: filter[field][op]=value - Supports complex filters with OR/AND logic **Pagination:** - /caregivers?page[offset]=0&page[limit]=10 - /caregivers?page[number]=1&page[size]=10 **Sorting:** - /caregivers?sort=-last_name,first_name - Prefix with '-' for descending order **Combined examples:** - /caregivers?query=maria&active=true&city=Athens - /caregivers?services=1,2&skills=nursing&filter[rating][gte]=4.0&sort=-rating - /caregivers?query=john&filter[city]=Athens&rating_min=4.5&sort=-created_at
     *
     * @tags Caregivers
     * @name ListCaregivers
     * @summary Get caregivers with unified filtering and search
     * @request GET:/caregivers
     * @secure
     */
    listCaregivers: (
      query?: {
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'last_name,-created_at'. Prefix with '-' for DESC.
         * @default "caregiver_id"
         */
        sort?: string | null;
        /**
         * Services
         * Filter by service IDs
         */
        services?: number[] | null;
        /**
         * Active
         * Filter by active status
         */
        active?: boolean | null;
        /**
         * City
         * Filter by city (exact match)
         */
        city?: string | null;
        /**
         * Skills
         * Filter by skills (match any)
         */
        skills?: string[] | null;
        /**
         * Languages Spoken
         * Filter by languages spoken (match any)
         */
        languages_spoken?: string[] | null;
        /**
         * Rating Min
         * Minimum rating
         */
        rating_min?: number | null;
        /**
         * Rating Max
         * Maximum rating
         */
        rating_max?: number | null;
        /**
         * Enabled Only
         * Filter by enabled status. None = show all, True = enabled only, False = disabled only
         */
        enabled_only?: boolean | null;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<CaregiversGetAllPaginationResponse, HTTPValidationError | void>({
        path: `/caregivers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new caregiver
     *
     * @tags Caregivers
     * @name CreateCaregiver
     * @summary Create new caregiver
     * @request POST:/caregivers
     * @secure
     */
    createCaregiver: (data: CaregiverCreate, params: RequestParams = {}) =>
      this.request<CaregiverWithServices, void | HTTPValidationError>({
        path: `/caregivers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportCaregivers
     * @summary Export the caregivers list
     * @request POST:/caregivers/export
     * @secure
     */
    exportCaregivers: (data: ExportRequest, params: RequestParams = {}) =>
      this.request<ExportStarted, void>({
        path: `/caregivers/export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportCaregiversTemplate
     * @summary Import template for the caregivers list
     * @request GET:/caregivers/import/template
     * @secure
     */
    importCaregiversTemplate: (params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/caregivers/import/template`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportCaregiversPreview
     * @summary Check an import of the caregivers list without saving
     * @request POST:/caregivers/import/preview
     * @secure
     */
    importCaregiversPreview: (data: BodyImportCaregiversPreview, params: RequestParams = {}) =>
      this.request<ImportReport, void | HTTPValidationError>({
        path: `/caregivers/import/preview`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportCaregiversCommit
     * @summary Import into the caregivers list, all rows or none
     * @request POST:/caregivers/import/commit
     * @secure
     */
    importCaregiversCommit: (data: BodyImportCaregiversCommit, params: RequestParams = {}) =>
      this.request<ImportReport, void | ImportReport | HTTPValidationError>({
        path: `/caregivers/import/commit`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a list of all caregivers
     *
     * @tags Caregivers
     * @name ListCaregiversMinified
     * @summary Get all caregivers with minified response schema
     * @request GET:/caregivers/minified
     * @secure
     */
    listCaregiversMinified: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /**
         * Services
         * Filter by service IDs
         */
        services?: number[] | null;
        /**
         * Active
         * Filter by active status
         */
        active?: boolean | null;
        /**
         * City
         * Filter by city (exact match)
         */
        city?: string | null;
        /**
         * Skills
         * Filter by skills (match any)
         */
        skills?: string[] | null;
        /**
         * Languages Spoken
         * Filter by languages spoken (match any)
         */
        languages_spoken?: string[] | null;
        /**
         * Rating Min
         * Minimum rating
         */
        rating_min?: number | null;
        /**
         * Rating Max
         * Maximum rating
         */
        rating_max?: number | null;
        /**
         * Enabled Only
         * Consider only enabled caregivers
         */
        enabled_only?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<CaregiversGetAllMinifiedPaginationResponse, HTTPValidationError | void>({
        path: `/caregivers/minified`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a caregiver by their ID
     *
     * @tags Caregivers
     * @name GetCaregiverById
     * @summary Get caregiver by ID
     * @request GET:/caregivers/{caregiver_id}
     * @secure
     */
    getCaregiverById: (caregiverId: number, params: RequestParams = {}) =>
      this.request<CaregiverWithServices, void | HTTPValidationError>({
        path: `/caregivers/${caregiverId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an existing caregiver
     *
     * @tags Caregivers
     * @name UpdateCaregiver
     * @summary Update caregiver
     * @request PUT:/caregivers/{caregiver_id}
     * @secure
     */
    updateCaregiver: (caregiverId: number, data: CaregiverUpdate, params: RequestParams = {}) =>
      this.request<CaregiverWithServices, void | HTTPValidationError>({
        path: `/caregivers/${caregiverId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a caregiver by id :param request: The request object :type request: Request :param caregiver_id: The ID of the caregiver to delete :type caregiver_id: int :param user_id: Optional; if sent it must be the caregiver's own account. The user is deleted too only when it is nothing but this caregiver. :type user_id: Optional[int] :raises HTTPException: If the caregiver is not found :raises HTTPException: If an error occurs while deleting the caregiver :return: No content :rtype: None
     *
     * @tags Caregivers
     * @name DeleteCaregiver
     * @summary Delete Caregiver
     * @request DELETE:/caregivers/{caregiver_id}
     * @secure
     */
    deleteCaregiver: (
      caregiverId: number,
      query?: {
        /** User Id */
        user_id?: number | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, void | HTTPValidationError>({
        path: `/caregivers/${caregiverId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Apply the same set of field changes to several caregivers in one transaction
     *
     * @tags Caregivers
     * @name BulkUpdateCaregivers
     * @summary Bulk update caregivers
     * @request PATCH:/caregivers/bulk
     * @secure
     */
    bulkUpdateCaregivers: (data: CaregiverBulkUpdateRequest, params: RequestParams = {}) =>
      this.request<CaregiverBulkUpdateResponse, void | HTTPValidationError>({
        path: `/caregivers/bulk`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Add a new shift for a caregiver
     *
     * @tags Shifts
     * @name CreateCaregiverShift
     * @summary Add a shift on the caregiver
     * @request POST:/caregivers/{caregiver_id}/shifts
     * @secure
     */
    createCaregiverShift: (caregiverId: number, data: ShiftCreate, params: RequestParams = {}) =>
      this.request<number, void | HTTPValidationError>({
        path: `/caregivers/${caregiverId}/shifts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fetches shifts assigned to a caregiver with optional from/to date filters.
     *
     * @tags Shifts
     * @name ListCaregiverShifts
     * @summary Get shifts for a caregiver
     * @request GET:/caregivers/{caregiver_id}/shifts
     * @secure
     */
    listCaregiverShifts: (
      caregiverId: number,
      query?: {
        /**
         * Offset
         * Pagination offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * Pagination limit
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /**
         * From
         * Filter from this date
         */
        from?: string | null;
        /**
         * To
         * Filter to this date
         */
        to?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<CaregiverShiftsPaginatedResponse, HTTPValidationError | void>({
        path: `/caregivers/${caregiverId}/shifts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create multiple shifts for a caregiver in a single request
     *
     * @tags Shifts
     * @name CreateCaregiverShiftsBatch
     * @summary Create multiple shifts for a caregiver
     * @request POST:/caregivers/{caregiver_id}/shifts/batch
     * @secure
     */
    createCaregiverShiftsBatch: (caregiverId: number, data: BatchShiftCreate, params: RequestParams = {}) =>
      this.request<BatchShiftCreateResult, void | HTTPValidationError>({
        path: `/caregivers/${caregiverId}/shifts/batch`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update multiple shifts for a caregiver in a single request
     *
     * @tags Shifts
     * @name UpdateCaregiverShiftsBatch
     * @summary Update multiple shifts for a caregiver
     * @request PUT:/caregivers/{caregiver_id}/shifts/batch
     * @secure
     */
    updateCaregiverShiftsBatch: (
      caregiverId: number,
      data: BatchShiftUpdate,
      query?: {
        /**
         * Force
         * Force update even if conflicts exist
         * @default false
         */
        force?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<BatchShiftUpdateResult, void | HTTPValidationError>({
        path: `/caregivers/${caregiverId}/shifts/batch`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete multiple shifts for a caregiver in a single request
     *
     * @tags Shifts
     * @name DeleteCaregiverShiftsBatch
     * @summary Delete multiple shifts for a caregiver
     * @request DELETE:/caregivers/{caregiver_id}/shifts/batch
     * @secure
     */
    deleteCaregiverShiftsBatch: (
      caregiverId: number,
      data: BatchShiftDelete,
      query?: {
        /**
         * Force
         * Force delete even if conflicts exist
         * @default false
         */
        force?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<BatchShiftDeleteResult, void | HTTPValidationError>({
        path: `/caregivers/${caregiverId}/shifts/batch`,
        method: 'DELETE',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Applies one set of schedule changes across MANY caregivers in a single request and a single transaction. Each entry in 'operations' names a caregiver and carries that caregiver's own creates, updates and deletes, because a recurring pattern lands differently on each of them - one person already has a Tuesday shift to update where the next needs one created. The per-caregiver batch endpoints under /caregivers/{caregiver_id}/shifts/batch remain, and are the right call for editing one person. This exists because scheduling a team through them costs up to three requests per caregiver: thirty caregivers meant ninety round-trips, and the client had no way to make them one unit of work. ALL OR NOTHING. Every caregiver's changes commit together or none of them do, which is the point of asking for them together: a half-applied team schedule leaves nobody able to say who was scheduled. With force=false a conflicting visit therefore aborts the WHOLE request (409) rather than part of it; with force=true the conflicts are applied and reported per caregiver.
     *
     * @tags Shifts
     * @name BulkCaregiverShifts
     * @summary Create, update and delete shifts for many caregivers
     * @request POST:/caregivers/shifts/bulk
     * @secure
     */
    bulkCaregiverShifts: (
      data: BulkShiftRequest,
      query?: {
        /**
         * Force
         * Apply even where a shift change unassigns a visit
         * @default false
         */
        force?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<BulkShiftResult, void>({
        path: `/caregivers/shifts/bulk`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns all caregiver shifts where the shift start date matches any of the provided dates.
     *
     * @tags Shifts
     * @name ListCaregiverShiftsByDates
     * @summary Fetch all caregiver shifts for a list of dates
     * @request GET:/caregivers/shifts/by-dates
     * @secure
     */
    listCaregiverShiftsByDates: (
      query: {
        /**
         * Offset
         * Pagination offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * Pagination limit
         * @min 1
         * @max 10000
         * @default 100
         */
        limit?: number;
        /**
         * Dates
         * List of dates (e.g. ?dates=2025-07-18&dates=2025-07-19)
         */
        dates: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<CaregiverShiftsPaginatedResponse, HTTPValidationError | void>({
        path: `/caregivers/shifts/by-dates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates an existing caregiver shift's notes, start time, and end time.
     *
     * @tags Shifts
     * @name UpdateCaregiverShift
     * @summary Update a caregiver shift
     * @request PUT:/caregivers/{caregiver_id}/shifts/{shift_id}
     * @secure
     */
    updateCaregiverShift: (
      caregiverId: number,
      shiftId: number,
      data: ShiftUpdate,
      query?: {
        /**
         * Force
         * Force update even if conflicts exist
         * @default false
         */
        force?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<CaregiverShiftUpdateResult, HTTPValidationError | void>({
        path: `/caregivers/${caregiverId}/shifts/${shiftId}`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a caregiver shift by its ID.
     *
     * @tags Shifts
     * @name DeleteCaregiverShift
     * @summary Delete a caregiver shift
     * @request DELETE:/caregivers/{caregiver_id}/shifts/{shift_id}
     * @secure
     */
    deleteCaregiverShift: (
      caregiverId: number,
      shiftId: number,
      query?: {
        /**
         * Force
         * Force delete even if conflicts exist
         * @default false
         */
        force?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<CaregiverShiftDeleteResult, void | HTTPValidationError>({
        path: `/caregivers/${caregiverId}/shifts/${shiftId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of dates within the specified range, indicating which dates have shifts. Useful for calendar views to show availability. Can be filtered by caregiver IDs. Each date includes a count of shifts and a boolean flag.
     *
     * @tags Shifts
     * @name CheckShiftsDateRange
     * @summary Check which dates have shifts in a date range
     * @request GET:/caregivers/shifts/date-range-check
     * @secure
     */
    checkShiftsDateRange: (
      query?: {
        /**
         * From
         * Start date (inclusive); defaults to today
         */
        from?: string | null;
        /**
         * To
         * End date (inclusive); defaults to today
         */
        to?: string | null;
        /**
         * Caregiver Ids
         * Filter by caregiver IDs
         */
        caregiver_ids?: number[] | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ShiftDateAvailability[], void | HTTPValidationError>({
        path: `/caregivers/shifts/date-range-check`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  caregiverGroups = {
    /**
     * @description Free text query; if not given return all; if given (>3 chars) searches by name
     *
     * @tags Caregiver Groups
     * @name ListCaregiverGroups
     * @summary Get caregiver groups (list or search)
     * @request GET:/caregiver-groups
     * @secure
     */
    listCaregiverGroups: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'name' or '-name'. Prefix with '-' for DESC.
         */
        sort?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<CaregiverGroupsGetAllPaginationResponse, HTTPValidationError | void>({
        path: `/caregiver-groups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new caregiver group record
     *
     * @tags Caregiver Groups
     * @name CreateCaregiverGroup
     * @summary Create new caregiver group
     * @request POST:/caregiver-groups
     * @secure
     */
    createCaregiverGroup: (data: CaregiverGroupCreate, params: RequestParams = {}) =>
      this.request<CaregiverGroup, void | HTTPValidationError>({
        path: `/caregiver-groups`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportCaregiverGroups
     * @summary Export the caregiver_groups list
     * @request POST:/caregiver-groups/export
     * @secure
     */
    exportCaregiverGroups: (data: ExportRequest, params: RequestParams = {}) =>
      this.request<ExportStarted, void>({
        path: `/caregiver-groups/export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a specific caregiver group by its ID
     *
     * @tags Caregiver Groups
     * @name GetCaregiverGroup
     * @summary Get caregiver group by ID
     * @request GET:/caregiver-groups/{caregiver_group_id}
     * @secure
     */
    getCaregiverGroup: (caregiverGroupId: number, params: RequestParams = {}) =>
      this.request<CaregiverGroup, void | HTTPValidationError>({
        path: `/caregiver-groups/${caregiverGroupId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an existing caregiver group's information
     *
     * @tags Caregiver Groups
     * @name UpdateCaregiverGroup
     * @summary Update caregiver group
     * @request PATCH:/caregiver-groups/{caregiver_group_id}
     * @secure
     */
    updateCaregiverGroup: (caregiverGroupId: number, data: CaregiverGroupUpdate, params: RequestParams = {}) =>
      this.request<CaregiverGroup, void | HTTPValidationError>({
        path: `/caregiver-groups/${caregiverGroupId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a caregiver group record by ID
     *
     * @tags Caregiver Groups
     * @name DeleteCaregiverGroup
     * @summary Delete caregiver group
     * @request DELETE:/caregiver-groups/{caregiver_group_id}
     * @secure
     */
    deleteCaregiverGroup: (caregiverGroupId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/caregiver-groups/${caregiverGroupId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  scheduling = {
    /**
     * @description Groups the non-cancelled visits in the window into caregiver-days (local dates in `timezone`) and routes each day through its visits in start-time order, one Mapbox Directions request per day. Results are computed per request and never stored. 404 when the feature is off, 503 when it is not configured or the usage counter is unreachable, 429 when the daily or monthly request cap is reached. 422 `route_distances_range_too_large` when the window needs more Mapbox requests than one call (or one day's cap) allows.
     *
     * @tags Scheduling
     * @name GetRouteDistances
     * @summary Road distance and drive time between each caregiver's consecutive visits
     * @request POST:/scheduling/route-distances
     * @secure
     */
    getRouteDistances: (data: RouteDistancesRequest, params: RequestParams = {}) =>
      this.request<RouteDistancesResponse, void>({
        path: `/scheduling/route-distances`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Automatically generates caregiver-visit assignments using a hybrid greedy + local optimization algorithm. The algorithm scores each caregiver-visit pairing based on multiple factors: 1. **Travel distance/time** - Prefer caregivers closer to visit location 2. **Already assigned hours** - Balance workload across caregivers 3. **Continuity with client** - Prefer caregivers who have worked with the client before 4. **Availability rank** - Prioritize less flexible caregivers first 5. **Fairness score** - Ensure even distribution of visits After greedy assignment, the algorithm attempts to resolve conflicts through: - Swapping assignments between caregivers - Reassigning conflicting visits to next-best caregiver - Local search heuristics **Preview Mode (default):** Set `preview_only=true` to generate assignments without saving to database. This allows you to review and modify the assignments before applying them. **Apply Mode:** Set `preview_only=false` to immediately save assignments to database. Alternatively, use the `/scheduling/apply` endpoint to apply confirmed assignments. **KPI Metrics:** The response includes comprehensive KPIs for quality assessment: - Travel distance metrics (avg distance between sequential visits) - Workload distribution (std dev of assigned minutes) - Continuity with clients (% of visits with familiar caregivers) - Resource utilization (scarce caregiver usage) - Fairness metrics (visit count distribution) - Quality indicators (shift coverage, service match, conflict rates)
     *
     * @tags Scheduling
     * @name AutoAssignCaregiversToVisits
     * @summary Generate automatic caregiver-visit assignments (preview or apply)
     * @request POST:/scheduling/auto-assign
     * @secure
     */
    autoAssignCaregiversToVisits: (data: SchedulingRequest, params: RequestParams = {}) =>
      this.request<SchedulingResult, void>({
        path: `/scheduling/auto-assign`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Apply user-confirmed scheduling assignments to the database. This endpoint is typically used after previewing assignments with `/scheduling/auto-assign` in preview mode. **Workflow:** 1. Call `/scheduling/auto-assign` with `preview_only=true` to generate assignments 2. Review the assignments in your UI, allow user to make modifications 3. Call this endpoint with the confirmed assignments to save them to database **Note:** This endpoint will replace existing assignments for the specified visits.
     *
     * @tags Scheduling
     * @name ApplySchedulingAssignments
     * @summary Apply confirmed scheduling assignments
     * @request POST:/scheduling/apply
     * @secure
     */
    applySchedulingAssignments: (data: ApplyAssignmentsRequest, params: RequestParams = {}) =>
      this.request<ApplyAssignmentsResult, void>({
        path: `/scheduling/apply`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  externalProviders = {
    /**
     * @description List external providers with pagination
     *
     * @tags External Providers
     * @name ListExternalProviders
     * @summary List external providers
     * @request GET:/external-providers
     * @secure
     */
    listExternalProviders: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /**
         * Query
         * Free text search by name
         */
        query?: string | null;
        /**
         * Active
         * Filter by active flag
         */
        active?: boolean | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'name' or '-name'.
         */
        sort?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExternalProvidersGetAllPaginationResponse, HTTPValidationError | void>({
        path: `/external-providers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create an external provider
     *
     * @tags External Providers
     * @name CreateExternalProvider
     * @summary Create external provider
     * @request POST:/external-providers
     * @secure
     */
    createExternalProvider: (data: ExternalProviderCreate, params: RequestParams = {}) =>
      this.request<ExternalProvider, void | HTTPValidationError>({
        path: `/external-providers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportExternalProviders
     * @summary Export the external_providers list
     * @request POST:/external-providers/export
     * @secure
     */
    exportExternalProviders: (data: ExportRequest, params: RequestParams = {}) =>
      this.request<ExportStarted, void>({
        path: `/external-providers/export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get one external provider
     *
     * @tags External Providers
     * @name GetExternalProvider
     * @summary Get external provider by ID
     * @request GET:/external-providers/{external_provider_id}
     * @secure
     */
    getExternalProvider: (externalProviderId: number, params: RequestParams = {}) =>
      this.request<ExternalProvider, void | HTTPValidationError>({
        path: `/external-providers/${externalProviderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an external provider
     *
     * @tags External Providers
     * @name UpdateExternalProvider
     * @summary Update external provider
     * @request PATCH:/external-providers/{external_provider_id}
     * @secure
     */
    updateExternalProvider: (externalProviderId: number, data: ExternalProviderUpdate, params: RequestParams = {}) =>
      this.request<ExternalProvider, void | HTTPValidationError>({
        path: `/external-providers/${externalProviderId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete an external provider
     *
     * @tags External Providers
     * @name DeleteExternalProvider
     * @summary Delete external provider
     * @request DELETE:/external-providers/{external_provider_id}
     * @secure
     */
    deleteExternalProvider: (externalProviderId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/external-providers/${externalProviderId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  health = {
    /**
     * @description Returns the health status and version of the service
     *
     * @tags Health
     * @name GetCaregiverServiceHealth
     * @summary Health check endpoint
     * @request GET:/health
     * @secure
     */
    getCaregiverServiceHealth: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/health`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  byUser = {
    /**
     * @description Retrieve a caregiver by their user ID including related services
     *
     * @tags Caregivers
     * @name GetCaregiverByUserId
     * @summary Get caregiver by user ID
     * @request GET:/by-user/{user_id}
     * @secure
     */
    getCaregiverByUserId: (userId: number, params: RequestParams = {}) =>
      this.request<CaregiverWithServices, void | HTTPValidationError>({
        path: `/by-user/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
